var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn flex flex-align-center",on:{"click":function($event){_vm.$emit('click')}}},[_c('div',{staticClass:"txt"},[_vm._t("default",[_vm._v("返回列表")])],2),_c('i',{staticClass:"fa fa-arrow-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }